// extracted by mini-css-extract-plugin
export var button = "_o2-2";
export var card = "_o2-0";
export var closeButtonContainer = "_o2-3";
export var iconContainer = "_o2-1";